'use client';

import {useEffect, useState} from 'react';

import Modal from 'components/Modal/Modal';
import terms_html from '../../html/terms.html';

const Terms = () => {
  const [component, set_component] = useState(null);

  useEffect(() => {
    const component = <div className='cylerian-terms' dangerouslySetInnerHTML={{__html: terms_html}} />;
    set_component(component);
  }, []);

  return component;
};

export default Terms;

